import React from 'react';
import { Section } from './ui/Section';
import { Check, BookOpen, ListChecks, Calendar, Zap, Gift } from 'lucide-react';
export function WhatsIncluded() {
  const items = [{
    icon: BookOpen,
    text: 'Ebook completo con el sistema 10–10–10 paso a paso'
  }, {
    icon: ListChecks,
    text: 'Checklists diarios (versión normal + versión mínima)'
  }, {
    icon: Calendar,
    text: 'Plan de 4 semanas para implementarlo sin burnout'
  }, {
    icon: Zap,
    text: 'Protocolo de 3 minutos para antojos de emergencia'
  }, {
    icon: Gift,
    text: 'Bonus: Lista de súper antiinflamación + combos simples'
  }];
  return <Section background="white" data-id="element-115">
      <h2 className="text-3xl font-bold text-center text-[#2C2C2C] mb-12" data-id="element-116">
        Qué incluye tu descarga
      </h2>

      <div className="grid gap-6" data-id="element-117">
        {items.map((item, idx) => <div key={idx} className="flex items-center p-4 bg-[#FFF8F0] rounded-lg" data-id="element-118">
            <item.icon className="h-6 w-6 text-[#D4735E] mr-4 flex-shrink-0" data-id="element-119" />
            <span className="text-[#2C2C2C] font-medium" data-id="element-120">{item.text}</span>
          </div>)}
      </div>
    </Section>;
}